import React from 'react';
import { IPostModel } from '../../../models';
import { useNavigate } from 'react-router-dom';
import { VideoWithShopHotspots } from '../video-shop-hotspots';

const PostTypeVideo = ({ post }: { post: IPostModel }) => {
  const navigate = useNavigate();
  if (post.postVideoResponses && post.postVideoResponses.length === 0)
    return null;

  const currentPath = window.location.pathname;
  return (
    <div
      className="cursor-pointer w-full"
      onDoubleClick={() => {
        // Double-tap ở feed → mở Reels (player dọc) tại đúng bài này.
        if (!currentPath.includes('reels')) {
          navigate(`/reels?start=${post.id}`);
        }
      }}
    >
      <div
        className="w-full"
        onClick={(e: any) => {
          e.stopPropagation();
        }}
      >
        <VideoWithShopHotspots
          config={{
            file: {
              attributes: {
                controlsList: 'nofullscreen',
                // iOS Safari: bắt buộc có playsInline mới phát được video trong trang
                // (thiếu nó + nofullscreen ⇒ iPhone không xem được video).
                playsInline: true,
                'webkit-playsinline': 'true',
              },
            },
          }}
          url={post?.postVideoResponses[0]?.url}
          width="100%"
          hotspotsJson={(post as any)?.videoHotspots}
        />
      </div>
    </div>
  );
};

export default PostTypeVideo;
